export default {
  field: {
    label: 'Categoria de imposto',
    placeholder: 'Sem categoria de imposto',
    unlinked_hint:
      'Sem uma, um produto usa a categoria de imposto da sua categoria de menu ou a taxa padrão do restaurante.',
    default_hint: 'Se for guardado sem uma, recebe a categoria de imposto predefinida do menu.',
  },
  empty: {
    hint: 'Ainda não há categorias de imposto — adicione uma abaixo.',
    read_only_hint: 'Ainda não foram configuradas categorias de imposto.',
  },
  option: {
    varies_by_channel: '(varia consoante o canal)',
  },
  load_error:
    'Não foi possível carregar as categorias de imposto — associar e desassociar estão desativados até isto carregar.',
  create: {
    name_placeholder: 'Nome da nova categoria',
    rate_placeholder: 'Taxa %',
    button: 'Adicionar categoria de imposto',
  },
  toasts: {
    create_error: 'Não foi possível criar a categoria de imposto.',
  },
};
